import actionTypes from '../constants/action-types';

const getPrices = () => ({
  type: actionTypes.GET_PRICES,
});

export default getPrices;
